import { Component, EventEmitter, inject, Input, Output, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';

export interface IMenuFooterEntity {
  label?: string;
  icon?: string;
  url: string;
  newTab: boolean;
  isCategory?: boolean;
}

export interface IMenuFooter {
  item: number;
  header: string;
  menu: IMenuFooterEntity[];
}

export interface IMenuCopyRight {
  menu: IMenuFooterEntity[];
  followUs: IMenuFooterEntity[];
}

export interface IFooter {
  logo: string;
  name: string;
  menu: IMenuFooter[];
  copyRight: IMenuCopyRight;
}

@Component({
  selector: 'lib-web-shared-ui-footer',
  imports: [RouterModule, MatButtonModule],
  templateUrl: './lib-footer.component.html',
  styleUrl: './lib-footer.component.scss',
})
export class LibFooterComponent {
  @Input() set data(value: IFooter) {
    this.dataSignal.set(value);
  }
  @Input() set footerlength(value: number) {
    this.footerlengthSignal.set(value);
    this.loggingService.log('footerlength => ', value);
  }
  @Output() OnClick = new EventEmitter();

  private readonly loggingService = inject(LoggingService);

  footerlengthSignal = signal<number>(0);
  dataSignal = signal<IFooter | undefined>(undefined);

  onClick(item: IMenuFooterEntity) {
    this.loggingService.log('item => ', item);
    this.OnClick.emit(item);
  }
}
